






import Vue from "vue";
import Component from "vue-class-component";

@Component({
  metaInfo: {
    title: "Dashboard"
  }
})
export default class AdminDashboard extends Vue {
}
